import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MapsComponent } from './components/maps/maps.component';
import { ProfileComponent } from './components/profile/profile.component';
import { BodyComponent } from './components/body/body.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { PaymentHistoryComponent } from './components/profile/payment-history/payment-history.component';
import { UpdateNotificationComponent } from './modals/update-notification/update-notification.component';
import { HttpClientModule } from '@angular/common/http';
import { AddOnsComponent } from './components/add-ons/add-ons.component';
import { CollaborationComponent } from './components/collaboration/collaboration.component';
import { SharedModule } from '../shared/shared.module';
import { DynamicModalComponent } from './modals/dynamic-modal/dynamic-modal.component';
import { NewFutureModalComponent } from './modals/new-future-modal/new-future-modal.component';
import { PurchaseModalComponent } from './modals/purchase-modal/purchase-modal.component';
import { UnsubscribeModalComponent } from './modals/unsubscribe-modal/unsubscribe-modal.component';
import { InvalidUserComponent } from './modals/invalid-user/invalid-user.component';
import { WelcomeBackComponent } from './modals/welcome-back/welcome-back.component';
import { EndSubscriptionComponent } from './modals/end-subscription/end-subscription.component';
import { NumberModalComponent } from './modals/number-modal/number-modal.component';
import { BlankNameComponent } from './modals/blank-name/blank-name.component';
import { BlankEmailComponent } from './modals/blank-email/blank-email.component';
import { AlreadyExistEmailModalComponent } from './modals/already-exist-email-modal/already-exist-email-modal.component';
import { PasswordMatchComponent } from './modals/password-match/password-match.component';
import { EndSubscriptionAddOnsComponent } from './modals/end-subscription-add-ons/end-subscription-add-ons.component';
import { RemoveCollaboratosComponent } from './modals/remove-collaboratos/remove-collaboratos.component';
import { SeatsNotAvailableComponent } from './modals/seats-not-available/seats-not-available.component';
import { GlobalNoteModalComponent } from './modals/global-note-modal/global-note-modal.component';
import { RecurlyErrorComponent } from './modals/recurly-error/recurly-error.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      {
        path: '',
        redirectTo: 'maps',
      },
      {
        path: 'maps',
        component: MapsComponent,
        pathMatch: 'full',
      },
      {
        path: 'addOns',
        component: AddOnsComponent,
        pathMatch: 'full',
      },
      {
        path: 'collaboration',
        component: CollaborationComponent,
        pathMatch: 'full',
      },
      {
        path: 'profile',
        component: ProfileComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  declarations: [
    DashboardComponent,
    SidenavComponent,
    NavbarComponent,
    MapsComponent,
    ProfileComponent,
    BodyComponent,
    PaymentHistoryComponent,
    UpdateNotificationComponent,
    AddOnsComponent,
    CollaborationComponent,
    UnsubscribeModalComponent,
    NewFutureModalComponent,
    DynamicModalComponent,
    PurchaseModalComponent,
    InvalidUserComponent,
    WelcomeBackComponent,
    EndSubscriptionComponent,
    NumberModalComponent,
    BlankNameComponent,
    BlankEmailComponent,
    AlreadyExistEmailModalComponent,
    PasswordMatchComponent,
    EndSubscriptionAddOnsComponent,
    RemoveCollaboratosComponent,
    SeatsNotAvailableComponent,
    GlobalNoteModalComponent,
    RecurlyErrorComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
  ],
})
export class DashboardModule {}
